import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cibFitbit,
  cilBraille,
  cilCash,
  cilChartLine,
  cilDollar,
  cilGlobeAlt,
  cilMobile,
  cilMovie,
  cilPeople,
  cilSettings,
  cilSpeech,
  cilTv,
  cilVideo,
  cilVoiceOverRecord,
  cilEnvelopeClosed,
} from '@coreui/icons'
import { CNavGroup, CNavItem } from '@coreui/react'
import { cilLocationPin } from '@coreui/icons/js/free'
import { PERMISSIONS } from '../../views/utils/permissions'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cibFitbit} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: 'Digital Library',
    icon: <CIcon icon={cilMovie} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Content Library',
        to: '/content',
      },
      {
        component: CNavItem,
        name: 'Asset Library',
        to: '/asset-Manager',
      },
    ],
    permission: [PERMISSIONS.CONTENT.READ],
  },

  {
    component: CNavItem,
    // as: NavLink,
    name: 'Live Studio',
    to: '/live-stream',
    icon: <CIcon icon={cilVideo} customClassName="nav-icon" />,
    permission: [PERMISSIONS.LIVE.READ],
  },
  {
    component: CNavGroup,
    name: 'Metadata',
    icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'System Defined',
        to: '/system-defined',
      },
      {
        component: CNavItem,
        name: 'Custom Fields',
        to: '/custom-fields',
      },
      {
        component: CNavItem,
        name: 'Censorship Rating',
        to: '/censorship-rating',
      },
    ],
    permission: [PERMISSIONS.META_DATA.READ],
  },
  {
    component: CNavGroup,
    name: 'Pricing',
    icon: <CIcon icon={cilDollar} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Subscription',
        to: '/subscription',
        permission: [PERMISSIONS.PRICING.READ],
      },
      {
        component: CNavItem,
        name: 'Pay per View',
        to: '/pay-per-view',
        permission: [PERMISSIONS.PRICING.READ],
      },
      {
        component: CNavItem,
        name: 'Payment Gateway',
        to: '/payment-gateway',
        permission: [PERMISSIONS.PAYMENT_GATEWAY.READ],
      },
      {
        component: CNavItem,
        name: 'Tax',
        to: '/tax',
        permission: [PERMISSIONS.PRICING.READ],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Discounts',
    icon: <CIcon icon={cilCash} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Discount',
        to: '/discount',
      },
      {
        component: CNavItem,
        name: 'Voucher',
        to: '/voucher',
      },
      {
        component: CNavItem,
        name: 'User Discount',
        to: '/user-discount',
      },
      {
        component: CNavItem,
        name: 'User Voucher',
        to: '/user-voucher',
      },
    ],
    permission: [PERMISSIONS.DISCOUNT.READ],
  },
  {
    component: CNavGroup,
    // as: NavLink,
    name: 'Website',
    icon: <CIcon icon={cilGlobeAlt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Static Pages',
        to: '/static-container',
      },
      {
        component: CNavItem,
        name: 'Home Page',
        to: '/home-page-web',
      },
      {
        component: CNavItem,
        name: 'Templates',
        to: '/templates',
      },
    ],
    permission: [PERMISSIONS.WEBSITE.READ],
  },
  {
    component: CNavGroup,
    name: 'User Management',
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Roles',
        to: '/roles-management',
      },
      {
        component: CNavItem,
        name: 'User Groups',
        to: '/user-groups',
      },
      {
        component: CNavItem,
        name: 'CMS Users',
        to: '/cms-users',
      },
      {
        component: CNavItem,
        name: 'Subscribers',
        to: '/subscribers',
      },
    ],
    permission: [PERMISSIONS.USER_MANAGEMENT.READ],
  },
  {
    component: CNavGroup,
    name: 'Content Partner',
    icon: <CIcon icon={cilVoiceOverRecord} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Content Partner',
        to: '/content-partners',
      },
      {
        component: CNavItem,
        name: 'Analytics',
        to: '/partner-analytics',
      },
    ],
    permission: [PERMISSIONS.CONTENT_PARTNER.READ],
  },
  {
    component: CNavGroup,
    name: 'Custom Form',
    icon: <CIcon icon={cilVoiceOverRecord} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Lead Partners',
        to: '/custom-forms/lead-partners',
      },
      {
        component: CNavItem,
        name: 'Custom Forms',
        to: '/custom-forms/list',
      },
      {
        component: CNavItem,
        name: 'Form Analytics',
        to: '/custom-forms/analytics',
      },
    ],
    permission: [PERMISSIONS.CUSTOM_FORMS.READ],
  },
  {
    component: CNavGroup,
    name: 'Analytics',
    icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Subscription',
        to: '/subscription-analytics',
      },
      {
        component: CNavItem,
        name: 'Content',
        to: '/content-analytics',
      },
      {
        component: CNavItem,
        name: 'Content Partner',
        to: '/content-partner-analytics',
      },
    ],
    permission: [PERMISSIONS.ANALYTICS.READ],
  },
  {
    component: CNavGroup,
    name: 'Marketing',
    icon: <CIcon icon={cilGlobeAlt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Campaigns',
        to: '/campaign/list',
      },
      {
        component: CNavItem,
        name: 'Audience',
        to: '/campaign/audience/list',
      },
      {
        component: CNavItem,
        name: 'Templates',
        to: '/campaign/choose-templates',
      },
      {
        component: CNavItem,
        name: 'Custom Properties',
        to: '/campaign/marketing-fields',
      },
    ],
    permission: [PERMISSIONS.CAMPAIGN_MARKETING.READ],
  },
  {
    component: CNavGroup,
    name: 'Affiliate Marketing',
    icon: <CIcon icon={cilBraille} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Affiliates',
        to: '/affiliates',
      },
      {
        component: CNavItem,
        name: 'Analytics',
        to: '/affiliates-analytics',
      },
    ],
    permission: [PERMISSIONS.AFFILIATES.READ],
  },
  {
    component: CNavGroup,
    name: 'Artist',
    icon: <CIcon icon={cilMovie} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Artist',
        to: '/artist',
      },
      {
        component: CNavItem,
        name: 'Artist Types',
        to: '/artist-types',
      },
    ],
    permission: [PERMISSIONS.ARTIST.READ],
  },
  {
    component: CNavItem,
    name: 'Venues',
    to: '/venue',
    icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
    permission: [PERMISSIONS.VENUE.READ],
  },
  {
    component: CNavItem,
    name: 'IPTV Channels',
    to: '/iptv-channels',
    icon: <CIcon icon={cilTv} customClassName="nav-icon" />,
    permission: [PERMISSIONS.IPTV_MODULE.READ],
  },
  // {
  //   component: CNavItem,
  //   name: 'IPTV Channels',
  //   to: '/iptv-channels',
  //   icon: <CIcon icon={cilTv} customClassName="nav-icon" />,
  //   permission: [PERMISSIONS.IPTV_CHANNELS.READ],
  // },
  {
    component: CNavItem,
    // as: NavLink,
    name: 'TV / Mobile Apps',
    to: '/tv-mobile-apps',
    icon: <CIcon icon={cilTv} customClassName="nav-icon" />,
    permission: [PERMISSIONS.MOBILE_APP.READ, PERMISSIONS.TV_APP.READ],
  },
  {
    component: CNavItem,
    name: 'Manage Account',
    to: '/manage-accounts',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    permission: [PERMISSIONS.ACCOUNT_MANAGEMENT.READ],
  },
  {
    component: CNavItem,
    name: 'Email Template',
    to: '/email-template',
    icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
    permission: [PERMISSIONS.EMAIL_TEMPLATE.READ],
  },
]

export default _nav
